module.exports = __webpack_public_path__ + "static/media/facts-bg.406774e6.jpg";